module.exports = __webpack_public_path__ + "74d21fb1b3559bb8ce35235c9d72010d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/irrigation3.jpg
// module id = 123
// module chunks = 1